<template>
  <div class="l-page l-page--analysis">
    <!-- サイドバーエリア -->
    <page-sidebar />
    <!-- /サイドバーエリア -->
    <main class="l-main">
      <div class="l-main-head">
        <!-- パンくずリスト -->
        <breadcrumb :breadcrumb-data="breadcrumbData" :additional-classes="['p-breadcrumb--analysis']" />
        <!-- /パンくずリスト -->
        <date-range-picker
          ref="refCalendarModal"
          :initial-start-date="calendarStartDate"
          :initial-end-date="calendarEndDate"
          :on-date-range-changed="onDateRangeChanged"
          cancel-button-label="キャンセル"
          enter-button-label="決定"
        />
      </div>
      <div class="l-main-content">
        <div class="p-analysis-timezone">
          <h2 class="c-title">
            <div class="c-title__text u-fs34">曜日と時間での傾向</div>
            <div class="c-date u-w400">
              <ul class="c-date-list">
                <li class="c-date-list__item c-date-list__item--label">表示期間</li>
                <li class="c-date-list__item c-date-list__item--from">{{ displayStartDate }}</li>
                <li class="c-date-list__item c-date-list__item--to">{{ displayEndDate }}</li>
              </ul>
            </div>
          </h2>
          <analysis-tab
            classes="c-tab--timezone"
            :current="tab.current"
            :on-select="onTabClick"
          />
          <h3 class="c-title">
            <div class="c-title__text u-fs--l">全ての配信結果に対してのクロス集計</div>
          </h3>
          <div
            class="p-analysis-timezone__heatmap"
            :class="[{'is-loading': isLoadingHeatmap}, {'is-empty': isEmpty}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <div class="c-graph-heatmap-timezone">
              <div class="c-graph-heatmap-timezone__row">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">月</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">火</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">水</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">木</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">金</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">土</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-x">日</div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="0_3">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  0〜3時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-0_3"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-0_3"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="3_6">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  3〜6時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-3_6"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-3_6"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="6_9">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  6〜9時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-6_9"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-6_9"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="9_12">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  9〜12時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-9_12"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-9_12"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="12_15">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  12〜15時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-12_15"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-12_15"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="15_18">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  15〜18時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-15_18"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-15_18"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="18_21">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  18〜21時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-18_21"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-18_21"></div>
              </div>
              <div class="c-graph-heatmap-timezone__row" data-time-type="21_0">
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--label-y">
                  21〜24時</div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_1-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_2-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_3-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_4-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_5-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_6-21_24"></div>
                <div class="c-graph-heatmap-timezone__cell c-graph-heatmap-timezone__cell--week_0-21_24"></div>
              </div>
            </div>
            <ul class="c-graph-heatmap-timezone-bar">
              <li class="c-graph-heatmap-timezone-bar__item"><span></span></li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r1"><span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r2"><span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r3"><span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r4"><span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r5"><span>-</span>
              </li>
              <li class="c-graph-heatmap-timezone-bar__item c-graph-heatmap-timezone-bar__item--r6"><span>-</span>
              </li>
            </ul>
            <ul class="c-graph-heatmap-timezone-bar-label-x">
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
              <li class="c-graph-heatmap-timezone-bar-label-x__item">-</li>
            </ul>

            <div class="c-tooltip c-tooltip--analysis c-tooltip--heatmap-timezone">
              <div class="c-tooltip__title">日曜 午前 3~6</div>
              <ul class="c-tooltip-list">
                <li class="c-tooltip-list__item c-tooltip-list__item--label">配信対象</li>
                <li class="c-tooltip-list__item c-tooltip-list__item--metrics">227,700</li>
              </ul>
            </div>
          </div>
          <h3 class="c-title c-title--download">
            <div class="c-title__text u-fs--l">全ての配信結果での合計数</div>
            <div class="c-text"><a :href="timezoneCsvUrl">CSVデータ ダウンロード</a></div>
          </h3>
          <div
            class="p-analysis-timezone__data"
            :class="[{'is-loading': isLoadingDataTable}, {'is-empty': isEmpty}]"
          >
            <div class="c-loader"></div>
            <div class="c-empty">
              <div class="c-empty__text">配信後にデータが反映されます</div>
            </div>
            <table class="c-table c-table--heatmap-timezone">
              <thead>
                <tr>
                  <th class="c-table__cell--center is-sortable">
                    <span class="c-table__text">曜日</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'weekId' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'weekId' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'weekId') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">時間</span>
                    <span
                      class="c-btn c-btn--sort"
                      @click="(e) => { onSortClick(e, 'hourId') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">配信対象数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'delivery' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'delivery' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'delivery') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">インプレッション</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'impression' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'impression' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'impression') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック数</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'click' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'click' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'click') }"
                    ></span>
                  </th>
                  <th class="c-table__cell--center u-w160 is-sortable">
                    <span class="c-table__text">クリック率(%)</span>
                    <span
                      class="c-btn c-btn--sort"
                      :class="[
                        {'c-btn--sort-asc': sort.key == 'ctr' && sort.type == 'asc'},
                        {'c-btn--sort-desc': sort.key == 'ctr' && sort.type == 'desc'},
                      ]"
                      @click="(e) => { onSortClick(e, 'ctr') }"
                    ></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

                <tr>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                  <td class="c-table__cell--center c-table__cell--middle">-</td>
                </tr>

              </tbody>
            </table>
          </div>
        </div>
      </div>
    </main>
    <!-- モーダル: エラーメッセージ表示 -->
    <error-modal
      :is-active=isError
      :message=errorMessage
      :on-close-click="onCloseErrorModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import dayjs from 'dayjs';
import 'dayjs/locale/ja';
dayjs.locale('ja');

export default {
  props: {
    breadcrumbData: Array,
    displayPeriod: Object,
  },
  data () {
    return {
      errorMessage: '',
      graphModule: null,
      isEmpty: false,
      isError: false,
      isLoadingHeatmap: true,
      isLoadingDataTable: true,
      isInitialized: false,
      range: {
        from: this.displayPeriod && this.displayPeriod.from && dayjs(this.displayPeriod.from).isValid()
          ? dayjs(this.displayPeriod.from).toDate()
          : dayjs().add(-30, 'days').toDate(),
        to: this.displayPeriod && this.displayPeriod.to && dayjs(this.displayPeriod.to).isValid()
          ? dayjs(this.displayPeriod.to).toDate()
          : dayjs().toDate(),
      },
      tab: {
        current: 'delivery',
      },
      sort: {
        key: 'delivery',
        type: 'desc'
      }
    }
  },

  computed: {
    calendarStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY-MM-DD')
        : dayjs().add(-30, 'days').format('YYYY-MM-DD')
    },
    calendarEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY-MM-DD')
        : dayjs().format('YYYY-MM-DD')
    },
    displayStartDate: function() {
      return dayjs(this.range.from).isValid()
        ? dayjs(this.range.from).format('YYYY/MM/DD')
        : '-'
    },
    displayEndDate: function() {
      return dayjs(this.range.to).isValid()
        ? dayjs(this.range.to).format('YYYY/MM/DD')
        : '-'
    },
    timezoneCsvUrl: function() {
      let url = '/api/analysis/summary-timezone/csv?' +
        'from=' + dayjs(this.range.from).format('YYYY-MM-DD') +
        '&to=' + dayjs(this.range.to).format('YYYY-MM-DD');
      return url;
    },

  },
  mounted: function() {
    // グラフモジュールの読み込み
    import('../../funcs/components/graph/graph-heatmap-delivery-timezone').then(module => {
      // モジュールオブジェクトをプロパティに設定
      this.graphModule = module;
      // モジュール読み込み後に初期化処理実行
      this.updateDataset();
    });
  },

  methods: {
    updateDataset: function() {
      // グラフモジュールの読み込みが完了していない場合は処理終了
      if (!this.graphModule) return;

      // ローダー表示設定
      this.isLoadingHeatmap = true;
      this.isLoadingDataTable = true;

      // 送信パラメーター作成
      const params = {
        from: dayjs(this.range.from).format('YYYY-MM-DD'),
        to: dayjs(this.range.to).format('YYYY-MM-DD'),
      }

      // ヒートマップ用データの取得処理実行
      axios.get(`/api/analysis/summary-timezone/${this.tab.current}`, {
        params
      }).then(res => {
        // レスポンスデータの内容がイレギュラーな場合は処理終了
        if (!res.data || !res.data.items) throw new Error('Invalid response data.');

        // ヒートマップ更新
        this.graphModule.heatmap(res.data);

        // データリスト更新
        this.graphModule.dataList({
          key: this.sort.key,
          order: this.sort.type,
        });

        // 初回読み込み時のみイベントバインディング処理を実行
        if (!this.isInitialized) {
          this.graphModule.setEvent();
          this.isInitialized = true;
        }

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingHeatmap = false;
          this.isLoadingDataTable = false;
        }, 300)
      }).catch(_e => {
        // エラーモーダル表示
        this.isError = true;
        this.errorMessage = '配信結果データの取得に失敗しました';

        // ローダー非表示設定
        setTimeout(() => {
          this.isLoadingHeatmap = false;
          this.isLoadingDataTable = false;
        }, 300)
      });
    },

    onTabClick: function(selected) {
      // 選択値が設定されていない場合は処理終了
      if (!selected) return;

      // 選択値が現在の選択値値と同じ場合は処理終了
      if (selected == this.tab.current) return

      // 選択値を現在のタブ名に設定
      this.tab.current = selected;

      // データ更新
      this.updateDataset();
    },

    onSortClick: function(e, key) {
      // ローダー表示設定
      this.isLoadingDataTable = true;

      // クリックしたソートボタンの状態で昇順・皇潤を判定 && ソートボタンの表示を切り替え
      if (e.target.classList.contains('c-btn--sort-desc')) {
        this.sort.key = key;
        this.sort.type = 'asc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-asc');
      } else {
        this.sort.key = key;
        this.sort.type = 'desc';
        e.target.classList.remove('c-btn--sort-asc');
        e.target.classList.remove('c-btn--sort-desc');
        e.target.classList.add('c-btn--sort-desc');
      }

      this.graphModule.dataList({
        key: this.sort.key,
        order: this.sort.type,
      });

      // ローダー非表示設定
      setTimeout(() => {
        this.isLoadingDataTable = false;
      }, 300)
    },

    onDateRangeChanged: function(range){
      // 取得データ期間の更新
      this.range.from = range.start;
      this.range.to= range.end;

      // データ更新
      this.updateDataset();
    },

    // -----------------------------------------------------------------------------------------------------
    // エミット系メソッド一覧: 子孫のUI操作にフックエミットコールされるか、引き渡した関数オブジェクトからコールされるメソッド
    // -----------------------------------------------------------------------------------------------------
    // クリック: エラーモーダルを閉じる処理
    onCloseErrorModal: function() {
      this.isError = false
      this.errorMessage = ''
    },
  }
}
</script>
